<template>
  <div :id="notificationId" class="toastify-content hidden flex">
    <component :is="icon" :class="[{ 'text-green-600': type === 'success' }, { 'text-orange-500': type === 'warning' }, { 'text-red-700': type === 'error' }]" />
    <div class="ml-4 mr-4 align-middle">
      <span class="font-medium">{{ message }}</span>
    </div>
  </div>
</template>
<script>
import Toastify from 'toastify-js'
import cash from 'cash-dom'
import { CheckCircleIcon, AlertTriangleIcon, AlertCircleIcon } from 'vue-feather-icons'

export default {
  components: {
    CheckCircleIcon,
    AlertTriangleIcon,
    AlertCircleIcon,
  },
  props: {
    timestamp: {
      type: Date,
      default: () => new Date(),
    },
    type: {
      type: String,
      default: 'info',
    },
    message: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    timeout: {
      type: Number,
      default: 5000,
    },
    gravity: {
      type: String,
      default: 'top',
    },
    position: {
      type: String,
      default: 'right',
    },
  },
  computed: {
    notificationId() {
      return `notification-${this.timestamp.getTime()}`
    },
  },
  mounted() {
    Toastify({
      node: cash('#' + this.notificationId).clone().removeClass('hidden')[0],
      duration: this.timeout,
      newWindow: true,
      gravity: this.gravity,
      position: this.position,
      stopOnFocus: true,
    }).showToast()
    if (this.timeout) {
      setTimeout(this.close, this.timeout)
    }
  },
  methods: {
    close() {
      this.$emit('on-close', this.timestamp)
    },
  },
}
</script>
